/* eslint-disable import/prefer-default-export */
import AppServices, { RawMaterialService } from '..';

import CustomFieldsService from '../customFields.service';
import { KpiReportService } from '../kpiReport.service';
import { MachineService } from '../machine.service';
import { MachineUIMetricsConfigService } from '../machineUiMetricsConfig.service';
import { MachinesGroupsService } from '../machinesGroups.service';
import MultipleStopsService from '../multipleStops.service';
import ProductionService from '../production.service';
import RealTimeService from '../realtime.service';
import { ReportsService } from '../reports.service';
import ServiceContext from './service.context';
import { ShiftService } from '../shift.service';
import { ShiftSettingsService } from '../shiftSettings.service';
import { StopAlertsService } from '../stopAlerts.service';
import StopSettingsService from '../stopSettings.service';
import StopsService from '../stops.service';
import TagsService from '../tags.service';
import { UserService } from '../user.service';
import { WhatsNewService } from '../whatsNew.service';
import { WorkOrderService } from '../workOrders.service';
import { SkuService } from '../sku.services';

function registerImplementations() {
  ServiceContext.register(
    MachinesGroupsService,
    AppServices.MachinesGroupsService
  );
  ServiceContext.register(UserService, AppServices.UserService);
  ServiceContext.register(TagsService, AppServices.TagsService);
  ServiceContext.register(StopSettingsService, AppServices.StopSettingsService);
  ServiceContext.register(KpiReportService, AppServices.KpiReportService);
  ServiceContext.register(ShiftService, AppServices.ShiftService);
  ServiceContext.register(MachineService, AppServices.MachineService);
  ServiceContext.register(RealTimeService, AppServices.RealTimeService);
  ServiceContext.register(StopsService, AppServices.StopsService);
  ServiceContext.register(StopAlertsService, AppServices.StopAlertsService);
  ServiceContext.register(
    ShiftSettingsService,
    AppServices.ShiftSettingsService
  );
  ServiceContext.register(
    MultipleStopsService,
    AppServices.MultipleStopsService
  );
  ServiceContext.register(ProductionService, AppServices.ProductionService);
  ServiceContext.register(RawMaterialService, AppServices.RawMaterialService);
  ServiceContext.register(ReportsService, AppServices.ReportsService);
  ServiceContext.register(WhatsNewService, AppServices.WhatsNewService);

  ServiceContext.register(WorkOrderService, AppServices.WorkOrdersService);
  ServiceContext.register(
    MachineUIMetricsConfigService,
    AppServices.MachineUIMetricsConfigService
  );
  ServiceContext.register(CustomFieldsService, AppServices.CustomFieldsService);
  ServiceContext.register(SkuService, AppServices.SkuService);
}

export function registerAllServices() {
  registerImplementations();
}
